import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home/index"),
    meta: { showLoading: true },
  },
  {
    path: "/location",
    name: "Location",
    component: () => import("@/views/Location/index"),
    meta: { showLoading: false },
  },
  {
    path: "/search",
    name: "Search",
    component: () => import("@/views/Search/index"),
    meta: { showLoading: false },
  },
  {
    path: "/thanks",
    name: "Thanks",
    component: () => import("@/views/Thanks/index"),
  },
  {
    path: "/aboutus",
    name: "AboutUs",
    component: () => import("@/views/AboutUs/index"),
    redirect: {
      name: "AboutUsProfile",
    },
    children: [
      {
        path: "profile",
        name: "AboutUsProfile",
        component: () => import("@/views/AboutUs/Profile/index"),
        meta: {
          showLoading: false,
          breadcrumb: [{
            name: '首頁',
            link: '/'
          },
          {
            name: '認識我們',
            link: '/aboutus'
          },
          {
            name: '公司簡介'
          }]
        }
      },
      {
        path: "honor",
        name: "AboutUsProfileHonor",
        component: () => import("@/views/AboutUs/Profile/Honor/index"),
        meta: {
          breadcrumb: [{
            name: '首頁',
            link: '/'
          },
          {
            name: '認識我們',
            link: '/aboutus'
          },
          {
            name: '公司簡介',
            link: '/aboutus/profile'
          },
          {
            name: '榮耀肯定'
          }]
        }
      },
      {
        path: "governance",
        name: "AboutUsGovernance",
        component: () => import("@/views/AboutUs/Governance/index"),
        meta: {
          breadcrumb: [{
            name: '首頁',
            link: '/'
          },
          {
            name: '認識我們',
            link: '/aboutus'
          },
          {
            name: '公司治理'
          }]
        }
      },
      {
        path: "socialresponsibility",
        name: "AboutUsSocialResponsibility",
        component: () => import("@/views/AboutUs/SocialResponsibility/index"),
        meta: {
          breadcrumb: [{
            name: '首頁',
            link: '/'
          },
          {
            name: '認識我們',
            link: '/aboutus'
          },
          {
            name: '永續發展'
          }]
        }
      },
      {
        path: "socialresponsibility/stakeholder",
        name: "AboutUsSocialResponsibilityStakeholder",
        component: () =>
          import("@/views/AboutUs/SocialResponsibility/Stakeholder/index"),
          meta: {
            breadcrumb: [{
              name: '首頁',
              link: '/'
            },
            {
              name: '認識我們',
              link: '/aboutus'
            },
            {
              name: '永續發展',
              link: '/aboutus/socialresponsibility'
            },
          {
              name: '利害關係人',
          }]
        }
      },
      {
        path: "socialresponsibility/staffcare",
        name: "AboutUsSocialResponsibilityStaffCare",
        component: () =>
          import("@/views/AboutUs/SocialResponsibility/StaffCare/index"),
          meta: {
            breadcrumb: [{
              name: '首頁',
              link: '/'
            },
            {
              name: '認識我們',
              link: '/aboutus'
            },
            {
              name: '永續發展',
              link: '/aboutus/socialresponsibility'
            },
          {
              name: '員工照顧',
          }]
        }
      },
      {
        path: "socialresponsibility/financial",
        name: "AboutUsSocialResponsibilityFinancial",
        component: () =>
          import("@/views/AboutUs/SocialResponsibility/Financial/index"),
          meta: {
            breadcrumb: [{
              name: '首頁',
              link: '/'
            },
            {
              name: '認識我們',
              link: '/aboutus'
            },
            {
              name: '永續發展',
              link: '/aboutus/socialresponsibility'
            },
          {
              name: '金融友善',
          }]
        }
      },
      {
        path: "socialresponsibility/socialcontributions",
        name: "AboutUsSocialResponsibilitySocialContributions",
        component: () =>
          import("@/views/AboutUs/SocialResponsibility/SocialContributions/index"),
          meta: {
            breadcrumb: [{
              name: '首頁',
              link: '/'
            },
            {
              name: '認識我們',
              link: '/aboutus'
            },
            {
              name: '永續發展',
              link: '/aboutus/socialresponsibility'
            },
          {
              name: '社會貢獻',
          }]
        }
      },
      {
        path: "socialresponsibility/environment",
        name: "AboutUsSocialResponsibilityEnvironment",
        component: () =>
          import("@/views/AboutUs/SocialResponsibility/Environment/index"),
          meta: {
            breadcrumb: [{
              name: '首頁',
              link: '/'
            },
            {
              name: '認識我們',
              link: '/aboutus'
            },
            {
              name: '永續發展',
              link: '/aboutus/socialresponsibility'
            },
          {
              name: '環境永續',
          }]
        }
      },
      {
        path: "socialresponsibility/news",
        name: "AboutUsSocialResponsibilityNews",
        component: () =>
          import("@/views/AboutUs/SocialResponsibility/News/index"),
          meta: {
            breadcrumb: [{
              name: '首頁',
              link: '/'
            },
            {
              name: '認識我們',
              link: '/aboutus'
            },
            {
              name: '永續發展',
              link: '/aboutus/socialresponsibility'
            },
          {
              name: '公益足跡',
          }]
        }
      },
      {
        path: "publicinfo",
        name: "AboutUsPublicInfo",
        component: () => import("@/views/AboutUs/PublicInfo/index"),
          meta: {
            breadcrumb: [{
              name: '首頁',
              link: '/'
            },
            {
              name: '認識我們',
              link: '/aboutus'
            },
            {
              name: '公開資訊',
            },
          ]
        }
      },
      {
        path: "publicinfo/message",
        name: "AboutUsPublicInfoMessage",
        component: () => import("@/views/AboutUs/PublicInfo/Message/index"),
          meta: {
            breadcrumb: [{
              name: '首頁',
              link: '/'
            },
            {
              name: '認識我們',
              link: '/aboutus'
            },
            {
              name: '公開資訊',
              link: '/aboutus/publicinfo'
            },
            {
              name: '重大訊息',
            },
          ]
        }
      },
      {
        path: "news",
        name: "AboutUsNews",
        component: () => import("@/views/AboutUs/News/index"),
          meta: {
            breadcrumb: [{
              name: '首頁',
              link: '/'
            },
            {
              name: '認識我們',
              link: '/aboutus'
            },
            {
              name: '最新消息',
            },
          ]
        }
      },
    ],
  },
  {
    path: "/shareholderservices",
    name: "ShareholderServices",
    component: () => import("@/views/AboutUs/ShareholderServices/index"),
  },
  {
    path: "/shareholderservices/detail",
    name: "ShareholderServicesDetail",
    component: () => import("@/views/AboutUs/ShareholderServices/Detail/index"),
  },
  {
    path: "/detail",
    name: "Detail",
    component: () => import("@/views/Detail/index"),
    meta: {
            breadcrumb: [],
        }
  },
  {
    path: "/customerservice",
    name: "CustomerService",
    component: () => import("@/views/CustomerService/index"),
    redirect: {
      name: "CustomerServiceClaimSettlement",
    },
    children: [
      {
        path: "goodservice",
        name: "CustomerServiceGoodService",
        component: () => import("@/views/CustomerService/GoodService/index"),
        meta: { showLoading: false },
      },
      {
        path: "claimsettlement",
        name: "CustomerServiceClaimSettlement",
        component: () =>
          import("@/views/CustomerService/ClaimSettlement/index"),
        meta: { showLoading: false },
      },
      {
        path: "paymentservice",
        name: "CustomerServicePaymentService",
        component: () => import("@/views/CustomerService/PaymentService/index"),
      },
      {
        path: "damageprevention",
        name: "CustomerServiceDamagePrevention",
        component: () => import("@/views/CustomerService/DamagePrevention/index"),
      },
      {
        path: "einsurance",
        name: "CustomerServiceEInsurance",
        component: () => import("@/views/CustomerService/EInsurance/index"),
      },
      {
        path: "compulsorylicense",
        name: "CustomerServiceCompulsoryLicense",
        component: () =>
          import("@/views/CustomerService/CompulsoryLicense/index"),
      },
      {
        path: "faq",
        name: "CustomerServiceFAQ",
        component: () => import("@/views/CustomerService/FAQ/index"),
        meta: { showLoading: false },
      },
      {
        path: "faq/detail",
        name: "CustomerServiceFAQDetail",
        component: () => import("@/views/CustomerService/FAQ/Detail/index"),
      },
      {
        path: "documentdownload/:type?",
        name: "CustomerServiceDocumentDownload",
        component: () =>
          import("@/views/CustomerService/DocumentDownload/index"),
      },
      {
        path: "documentdownload/productterms",
        name: "CustomerServiceDocumentDownloadTerms",
        component: () =>
          import("@/views/CustomerService/DocumentDownload/ProductTerms/index"),
      },
      {
        path: "contactus",
        name: "CustomerServiceContactUs",
        component: () => import("@/views/CustomerService/ContactUs/index"),
      },
      {
        path: "signlanguage",
        name: "CustomerServiceSignLanguage",
        component: () => import("@/views/CustomerService/SignLanguage/index"),
      },
      {
        path: "multilanguage",
        name: "CustomerServiceMultiLanguage",
        component: () => import("@/views/CustomerService/MultiLanguage/index"),
      },
    ],
  },
  {
    path: "/decree",
    name: "Decree",
    component: () => import("@/views/guide_and_declaration/Decree/index"),
  },
  {
    path: "/product",
    name: "Product",
    component: () => import("@/views/Product/index"),
    redirect: {
      name: "ProductIntro",
    },
    children: [
      {
        path: "intro/:type?",
        name: "ProductIntro",
        component: () => import("@/views/Product/Intro/index"),
        meta: { showLoading: false },
      },
      {
        path: "description/:type?",
        name: "ProductDescription",
        component: () => import("@/views/Product/Description/index"),
      },
      {
        path: "cliamsettlementintro/:type?",
        name: "ProductCliamSettlementIntro",
        component: () => import("@/views/Product/CliamSettlementIntro/index"),
      },
    ]
  },
  {
    path: "/sitemap",
    name: "Sitemap",
    component: () => import("@/views/guide_and_declaration/Sitemap/index"),
  },
  {
    path: "/customerprotectionstatement",
    name: "CustomerProtectionStatement",
    component: () => import("@/views/guide_and_declaration/CustomerProtectionStatement/index"),
  },
  {
    path: "/customize/:page?",
    name: "Customize",
    component: () => import("@/views/Customize/index"),
    meta: { showLoading: false },
  },
  {
    path: "/productcombo",
    name: "ProductCombo",
    component: () => import("@/views/ProductCombo/index"),
  },
  {
    path: "*",
    name: "404",
    component: () => import("@/views/404/index"),
  },
  {
    path: "/differenceservice/:id?",
    name: "DifferenceService",
    component: () => import("@/views/DifferenceService/index"),
  },
];

const createRouter = () =>
  new VueRouter({
    scrollBehavior: () => ({ y: 0 }),
    mode: "history",
    base: process.env.BASE_URL,
    routes,
  });

const router = createRouter();

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
